var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "commoditysearchstyle" },
    [
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { "label-width": "80px", model: _vm.datas, size: "small" } },
        [
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "框体内容" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入内容" },
                model: {
                  value: _vm.datas.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "content", $$v)
                  },
                  expression: "datas.content",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "20px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "框体样式" } },
            [
              _c("el-slider", {
                attrs: {
                  max: 20,
                  min: 0,
                  "input-size": "mini",
                  "show-input": "",
                },
                model: {
                  value: _vm.datas.borderRadius,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "borderRadius", $$v)
                  },
                  expression: "datas.borderRadius",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "显示位置" } },
            [
              _c("div", { staticClass: "weiz" }, [
                _c("i", {
                  staticClass: "zdy-icon icon-font-left",
                  class: _vm.datas.positions === "left" ? "active" : "",
                  on: {
                    click: function ($event) {
                      _vm.datas.positions = "left"
                    },
                  },
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "zdy-icon icon-font-center",
                  class: _vm.datas.positions === "center" ? "active" : "",
                  on: {
                    click: function ($event) {
                      _vm.datas.positions = "center"
                    },
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef borrediu", attrs: { label: "框体高度" } },
            [
              _c("el-slider", {
                attrs: {
                  max: 50,
                  min: 28,
                  "input-size": "mini",
                  "show-input": "",
                },
                model: {
                  value: _vm.datas.height,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "height", $$v)
                  },
                  expression: "datas.height",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "展示图标" } },
            [
              _c("el-switch", {
                model: {
                  value: _vm.datas.showIcon,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "showIcon", $$v)
                  },
                  expression: "datas.showIcon",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "背景颜色" } },
            [
              _c("el-color-picker", {
                staticClass: "picke",
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.backgroundColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "backgroundColor", $$v)
                  },
                  expression: "datas.backgroundColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "框体颜色" } },
            [
              _c("el-color-picker", {
                staticClass: "picke",
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.borderColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "borderColor", $$v)
                  },
                  expression: "datas.borderColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "文本颜色" } },
            [
              _c("el-color-picker", {
                staticClass: "picke",
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.textColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "textColor", $$v)
                  },
                  expression: "datas.textColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "图标颜色" } },
            [
              _c("el-color-picker", {
                staticClass: "picke",
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.iconColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "iconColor", $$v)
                  },
                  expression: "datas.iconColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "lef",
              attrs: {
                label: "字体大小",
                prop: "textSize",
                "hide-required-asterisk": true,
              },
            },
            [
              _c("el-input", {
                attrs: { type: "number", placeholder: "请输入字体大小" },
                model: {
                  value: _vm.datas.textSize,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "textSize", _vm._n($$v))
                  },
                  expression: "datas.textSize",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }